"use client";

import { Card, Col, Row, Typography } from "antd";
import { useEffect } from "react";
import Head from "next/head";
import PDFViewer from "@/components/common/PDFViewer";
import MKTScript from "../MKTScript";

const { Title } = Typography;

const PaymentPolicy = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MKTScript />
      <Head>
        <title>Phương thức thanh toán | {process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}</title>
        <meta
          name="description"
          content={`Phương thức thanh toán của ${process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}`}
        />
      </Head>
      <div className="payment-policy-container">
        <Row justify="center" style={{ padding: "20px" }}>
          <Col xs={24} sm={22} md={20} lg={18} xl={16}>
            <Card
              variant="borderless"
              style={{
                marginBottom: "2rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              }}
            >
              <Title
                level={1}
                style={{ textAlign: "center", marginBottom: "2rem" }}
              >
                HÌNH THỨC THANH TOÁN TẠI WEBSITE TRAVELEASY.VN
              </Title>

              <PDFViewer
                file="/static/docs/payment-policy.pdf"
                title="Phương thức thanh toán chi tiết"
                width={800}
                showControls={true}
                showDownload={true}
                className="payment-policy-pdf"
              />
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx global>{`
        .payment-policy-container {
          background-color: #f5f5f5;
          min-height: 100vh;
          padding: 2rem 0;
        }

        .payment-policy-pdf {
          width: 100%;
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .payment-policy-container {
            padding: 1rem 0;
          }
          
          .payment-policy-pdf {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default PaymentPolicy;